import { create } from 'zustand';

import { FAQsItem } from '@mygpt/app/faqs/services/list';

interface FAQsStore {
  records: Record<string, FAQsItem[]>;
  cacheTotal: Record<string, number>;
}

export const faqsStore = create<FAQsStore>(() => ({
  records: {},
  cacheTotal: {},
}));
